import React from 'react';
import styles from './CSSZSickLeaveCertificateFormHeadline.module.scss';
import Text from '../../../../../Components/Base/Text/Text';

interface Props {
	title: string;
}

const CSSZSickLeaveCertificateFormHeadline: React.FC<Props> = ({ title }) => {
	return (
		<div className={styles.wrapper}>
			<Text tx={title} className={styles.title} />
			<div className={styles.line} />
		</div>
	);
};

export default CSSZSickLeaveCertificateFormHeadline;
